/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bakery_Intro_List_41Inputs */

const en_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use stamps in the Exchange Shop to redeem missing cakes.`)
};

const ar_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدم الطوابع في متجر الاستبدال لاسترداد الكعكات الناقصة.`)
};

const de_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwende Stempel im Einlöse-Shop, um fehlende Kuchen einzutauschen.`)
};

const es_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa sellos en la Tienda de canje para conseguir los pasteles que te faltan.`)
};

const fr_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez les timbres dans la boutique d'échange pour obtenir les gâteaux manquants.`)
};

const it_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa i timbri nel Negozio di Scambio per riscattare le torte mancanti.`)
};

const ja_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交換ショップでスタンプを使って、まだ持っていないケーキと交換しましょう。`)
};

const ko_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`교환 상점에서 스탬프를 사용하여 없는 케이크를 교환하세요.`)
};

const pt_br_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use selos na Loja de Trocas para resgatar os bolos que faltam.`)
};

const ru_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте штампы в Магазине обмена, чтобы получить недостающие торты.`)
};

const th_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้แสตมป์ในร้านค้าแลกเปลี่ยนเพื่อแลกรับเค้กที่ยังไม่มี`)
};

const tr_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksik pastaları almak için Takas Mağazası'nda pulları kullanın.`)
};

const zh_cn_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印花可以在印花兑换商店里兑换尚未收集到的蛋糕。`)
};

const zh_tw_bakery_intro_list_41 = /** @type {(inputs: Bakery_Intro_List_41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印花可以在印花兌換商店裡兌換尚未收集到的蛋糕。`)
};

/**
* | output |
* | --- |
* | "Use stamps in the Exchange Shop to redeem missing cakes." |
*
* @param {Bakery_Intro_List_41Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const bakery_intro_list_41 = /** @type {((inputs?: Bakery_Intro_List_41Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bakery_Intro_List_41Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bakery_intro_list_41(inputs)
	if (locale === "ar") return ar_bakery_intro_list_41(inputs)
	if (locale === "de") return de_bakery_intro_list_41(inputs)
	if (locale === "es") return es_bakery_intro_list_41(inputs)
	if (locale === "fr") return fr_bakery_intro_list_41(inputs)
	if (locale === "it") return it_bakery_intro_list_41(inputs)
	if (locale === "ja") return ja_bakery_intro_list_41(inputs)
	if (locale === "ko") return ko_bakery_intro_list_41(inputs)
	if (locale === "pt_br") return pt_br_bakery_intro_list_41(inputs)
	if (locale === "ru") return ru_bakery_intro_list_41(inputs)
	if (locale === "th") return th_bakery_intro_list_41(inputs)
	if (locale === "tr") return tr_bakery_intro_list_41(inputs)
	if (locale === "zh_cn") return zh_cn_bakery_intro_list_41(inputs)
	return zh_tw_bakery_intro_list_41(inputs)
});
export { bakery_intro_list_41 as "Bakery_intro_list_4" }